<template>
    <div class="navbar" :class="{'navbar__expanded':isOpen}" 
        @click="onNavBarClick" 
        v-click-outside="()=>{this.toggleMenu(false) }" >
        <v-nav-logo :expand="isOpen"/>
        <transition name="expand">
            <v-nav-search :expand="isOpen" v-model="search" @click="onSearchClick" />
        </transition>

        <v-nav-menu v-if="user" 
            ref="menu"
            :expand="isOpen"
            :search="search"
            :menu="user.menu"
            @routeClick="handleRouteClick"
            @submenuClick="()=>{ this.toggleMenu(true) }"/>
    </div>
</template>

<script>
import vNavMenu from './modules/NavMenu.vue'
import vNavLogo from './modules/NavLogo.vue'
import vNavSearch from './modules/vNavSearch.vue'

import { mapState, mapActions } from 'vuex'

export default {
    name:'vNavbar',
    computed: {
        ...mapState({
            user: state => state.profile.user,
            isOpen: state => state.sideMenu.isOpen
        })
    },
    components:{
        vNavMenu,
        vNavLogo,
        vNavSearch,
    },
    data() {
        return {
            expand:false,
            search: ''
        }
    }, 
    methods: {
        ...mapActions([
            'TOGGLE_SIDE_MENU'
        ]),
        handleRouteClick() {
            this.search =""
            this.toggleMenu(false)
        },
        toggleMenu(val) {
            this.TOGGLE_SIDE_MENU(val)
        },
        onNavBarClick(e) {
                const target = e.target
                const classes=['navbar-nav__list','navbar', 'navbar-logo__large', 'navbar-nav','navbar-logo__img']
                if(classes.some(item => target.classList.contains(item))) this.toggleMenu(!this.isOpen)
        },
        onSearchClick() {
            if(!this.isOpen) this.toggleMenu(true)
        }
    }
}
</script>

<style lang="scss">
    @import '../../../../gulp-src/app/scss/variables';
    .navbar {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        z-index: 101;
        display: flex;
        flex-direction: column;
        background-color: $global-dark-3a;

        @media (min-width: 1500px) {
            padding: 0 16px;
        }
    }
    
    .expand-enter-active, .expand-leave-active {
        transition: .5s;
    }
    .expand-enter, .expand-leave-to {
        max-width: 0;
        opacity: 0;
        
    }

    @media screen and (max-width: 767.98px) {
        .navbar { 
            max-width: 0%;
            overflow: hidden;
            &__expanded {
                max-width: 280px;
            }
        }
        .expanded {
            max-width: 280px;
        }
        
    }
</style>
